// extracted by mini-css-extract-plugin
export default {"largeBubbleContainer":"largebubble_largeBubbleContainer__Vu+XH"};